import {
  LocaleEnum,
  Readable,
  Author,
  AuthorQuery,
  AuthorQueryVariables,
  AuthorDocument,
  SearchReadablesDocument,
  SearchReadablesQuery,
  SearchReadablesQueryVariables,
  Metadata,
} from 'generated/apolloComponents'
import getT from 'next-translate/getT'
import { addApolloState, initializeApollo } from '@/api/apollo'
import AuthorTemplate from '@/components/templates/Author'
import CustomHead from '@/components/molecules/CustomHead'

interface IProps {
  author: Author
  articles: Readable[]
  metaData: Metadata
}

const AuthorPage = ({ author, articles, metaData }: IProps) =>
  author && (
    <>
      <CustomHead metaData={metaData} />
      <AuthorTemplate author={author} articles={articles} />
    </>
  )

export const getServerSideProps = async (context: any) => {
  let props = {}
  const t = await getT(context.locale, 'author')
  const apolloClient = initializeApollo({ ctx: context })

  if (context.params?.slug) {
    const authorData = await apolloClient.query<
      AuthorQuery,
      AuthorQueryVariables
    >({
      query: AuthorDocument,
      variables: {
        authorId: context.params?.slug,
      },
      errorPolicy: 'all',
    })

    if (authorData.errors || !authorData.data.author) {
      return {
        redirect: {
          destination: '/readme',
          permanent: true,
        },
      }
    }
    const articlesData = await apolloClient.query<
      SearchReadablesQuery,
      SearchReadablesQueryVariables
    >({
      query: SearchReadablesDocument,
      variables: {
        perPage: 64,
        language: LocaleEnum[context.locale as 'pl' | 'en'],
        filters: { authorId: authorData.data.author?.id },
      },
    })

    const metaData = {
      title: t('author:title', { name: authorData.data.author?.name }),
      description: t('author:description'),
    }
    props = {
      ...props,
      ...{
        author: authorData.data.author,
        articles: articlesData.data.searchReadables.nodes,
        metaData: metaData,
      },
    }
  }

  return addApolloState(apolloClient, {
    props: props,
  })
}

export default AuthorPage
